<template>
  <div :class="bem('')">
    <div :class="bem('header')">
      <h2 v-html="loading ? '&nbsp;' : title"></h2>
      <p v-if="description.length">{{ description }}</p>
    </div>
    <div :class="bem('inner')">
      <div :class="bem('products')" v-if="products.length">
        <Carousel
          :class="bem('product-carousel')"
          :options="productCarouselOptions"
          ref="carousel">
          <Slide
            v-if="hasCutomSlide($screen.width, video_mobile, image_mobile)"
            class="slide--main">
            <div class="image-wrapper" style="--aspect-ratio: 1">
              <template v-if="video_mobile.length">
                <VVideo :video="video_mobile[0]" />
                <a class="video-link-layer" :href="url_mobile"> </a>
              </template>
              <a v-else :href="url_mobile">
                <img :src="image_mobile ? image_mobile[0].src : null" />
              </a>
            </div>
          </Slide>
          <Slide
            class="slide--main"
            v-for="product in products"
            :key="product.node.id">
            <a
              :href="urlWithinCollection(product.node.handle, product.node.onlineStoreUrl)"
              :title="product.node.title"
              :aria-label="product.node.title">
              <div class="image-wrapper" style="--aspect-ratio: 1">
                <VImg
                  :media="media(product)"
                  @loaded="featuredLazyLoaded = true" />
              </div>
              <Loading :activated="!featuredLazyLoaded" />
              <div :class="bem('product-details')">
                <h3 v-text="product.node.title"></h3>
                <p
                  v-text="
                    $money(
                      product.node.variants.edges[0].node.priceV2.amount * 100
                    )
                  "></p>
              </div>
            </a>
          </Slide>
        </Carousel>
        <Carousel
          :class="bem('thumbnails')"
          :options="thumbnailCarouselOptions"
          ref="thumbnails">
          <Slide
            v-if="hasCutomSlide($screen.width, video_mobile, image_mobile)"
            class="slide--thumbnail">
            <div style="--aspect-ratio: 1">
              <VVideo v-if="video_mobile.length" :video="video_mobile[0]" />
              <img v-else :src="image_mobile ? image_mobile[0].src : null" />
            </div>
          </Slide>
          <Slide
            class="slide--thumbnail"
            v-for="(product, idx) in products"
            :key="idx">
            <div
              :class="{ active: activeSlideIdx === idx }"
              @click="activeSlideIdx = idx"
              style="--aspect-ratio: 1">
              <VImg :media="media(product)" fixedSize="250x" />
            </div>
          </Slide>
        </Carousel>
      </div>
      <div
        v-if="$screen.tablet_m_up"
        :class="[bem('banner'), contain]"
        style="--aspect-ratio: 0.725">
        <VVideo v-if="video.length" :video="video[0]" />
        <VImg v-else :src="image ? image.src : null" />
        <p :class="[bem('banner-text'), 'h3']" v-text="description"></p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { print } from "graphql";
import { Splide, SplideSlide } from "@splidejs/vue-splide";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";
import { collectionProducts } from "../../scripts/graphql/collection.graphql";
import Loading from "./Loading";
import VImg from "./VImg";
import VVideo from "./VVideo";

export default {
  name: "SubCollection",

  components: {
    Carousel: Splide,
    Slide: SplideSlide,
    Loading,
    VImg,
    VVideo,
  },

  props: ["handle"],

  computed: {
    productCarouselOptions() {
      return {
        gap: this.$screen.tablet_up ? 16 : 8,
        drag: true,
        perPage: 1,
        perMove: 1,
        arrows: true,
        pagination: false,
      };
    },
    thumbnailCarouselOptions() {
      return {
        gap: this.$screen.tablet_up ? 8 : 2,
        drag: true,
        perPage: this.$screen.tablet_up ? 5 : 5,
        perMove: 1,
        arrows: true,
        pagination: false,
        isNavigation: true,
      };
    },
  },

  data() {
    return {
      title: "",
      description: "",
      image: null,
      video: [],
      video_mobile: [],
      image_mobile: [],
      url_mobile: '',
      products: [],
      featuredLazyLoaded: false,
      activeSlideIdx: 0,
      loading: true,
    };
  },

  created() {
    const data = JSON.stringify({
      query: print(collectionProducts),
      variables: {
        handle: this.handle,
        country: globalThis.PSTheme.Settings.Currency.country,
      },
    });
    const config = { ...globalThis.PSTheme.GraphQL, data };
    axios(config)
      .then((res) => {
        const collection = res.data.data.collectionByHandle;
        this.title = collection.title;
        this.description = collection.description;
        this.image = collection.image;
        this.video = collection.video ? JSON.parse(collection.video.value) : [];

        // * MOBILE
        this.video_mobile = collection.mobile_video ? JSON.parse(collection.mobile_video.value) : [];
        this.image_mobile = collection.mobile_image ? JSON.parse(collection.mobile_image.value) : [];
        this.url_mobile = collection.mobile_url ? collection.mobile_url.value : '';

        this.products = collection.products.edges;
        this.loading = false;
        this.$nextTick(() => {
          this.$refs.carousel.sync(this.$refs.thumbnails.splide);
        });
      })
      .catch((error) => {
        console.error(error);
      });
  },

  methods: {
    urlWithinCollection(handle, onlineStoreUrl) {
      const path = window.location.pathname;
      if (path.includes('collections/')) {
        if (path.includes('women') || path.includes('men')) {
          const collectionsUrl =
            window.location.pathname.split('collections/')[1];
          const firstCollectionHandle = collectionsUrl.split('/')[0];
          return `${document.location.origin}/collections/${firstCollectionHandle}/products/${handle}`;
        }
      }
      return onlineStoreUrl;
    },

    hasCutomSlide(width, video, image) {
      if (width < 980 && (video.length || image.length)) {
        return true;
      }
      return false;
    },

    // collectionUrl(handle) {
    //   return `${window.location.origin}/collections/${handle}`;
    // },

    media(product) {
      return product.node.media.edges[0]?.node.image;
    },

    updateIdx(event) {
      if (event === "backward" && this.activeSlideIdx !== 0) {
        this.activeSlideIdx--;
      }
      if (
        event === "forward" &&
        this.activeSlideIdx + 1 !== this.products.length
      ) {
        this.activeSlideIdx++;
      }
    },
  },
};
</script>

<style lang="scss">
.sub-collection__inner {
  padding-bottom: var(--heading-font);

  @include mq(--tablet-m-up) {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 1fr;
    column-gap: 2.25rem;
  }
}

.sub-collection__header {
  h2 {
    font-size: var(--text-lg);
    padding-bottom: 0.625rem;
  }

  p {
    margin: -1rem 0 0.9375rem;
  }
  @include mq(--tablet-m-up) {
    h2 {
      font-size: 1.5rem;
      padding-bottom: 0;
    }
  }
}

.sub-collection__products {
  position: relative;
}

.sub-collection__product-details {
  p {
    margin: -1rem 0 0.9375rem;
  }
}

.sub-collection__banner {
  position: relative;
}

.sub-collection__banner-text {
  display: none;
  padding: var(--gutter);
  position: absolute;
  bottom: 0;
  left: 0;
  font-family: "SofiaPro-Bold";
  font-style: normal;
  font-size: 1.375rem;
  font-weight: 700;
  line-height: 1.2;
  color: var(--white);
  margin-bottom: 0;
}

.slide--main {
}

.slide--thumbnail {
  .active {
    border: thin solid var(--overcast);
  }
}
// .sub-collection__thumbnails {
//   @media screen and (max-width: 979px) {
//     .splide__slide:first-child {
//       display: none !important;
//       // width: 0 !important;
//       // height: 0 !important;
//       // opacity: 0 !important;
//     }
//   }
// }
.video-link-layer{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 5;
  height: 100%;
}
</style>
